import { render, staticRenderFns } from "./InitialScreen.vue?vue&type=template&id=4c471948&"
import script from "./InitialScreen.vue?vue&type=script&lang=js&"
export * from "./InitialScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports